import { ScheduledDiscovery, DiscoverySettings, DiscoveryMethod } from 'DiscoveryEngine.TS/Discovery';
import { Schedule, ScheduleType, Guid } from 'DiscoveryEngine.TS/Utils';

export class SchedDiscData {
	public SchedDisc: ScheduledDiscovery;
	public DiscSettings: DiscoverySettings;

	constructor() {
		this.DiscSettings = new DiscoverySettings();
		this.DiscSettings.VerifyGuid();
		this.DiscSettings.Name = "New Scheduled Discovery";
		this.DiscSettings.Method = DiscoveryMethod.PingSweep;

		let now = new Date();

		this.SchedDisc = new ScheduledDiscovery();
		this.SchedDisc.VerifyGuid();
		this.SchedDisc.Name = "ScheduledDiscovery";
		this.SchedDisc.DiscSettingsId = new Guid(this.DiscSettings.GUID);
		this.SchedDisc.Schedule.Type = ScheduleType.Days_Interval;
		this.SchedDisc.Schedule.OneInterval = 1;
		this.SchedDisc.Schedule.OneStartTime = new Date(now.getFullYear(), now.getMonth(), now.getDay(), 0, 0, 0, 0);
		this.SchedDisc.Enabled = true;
		this.SchedDisc.Keep = 1;

	}
}
